<template>
  <div class="main_center">
    <div class="content">

        <searchBox
                :dialogVisible.sync="moreSearchItem"
                @dialogCancle="dialogCancle"
                title="更多筛选">
            <div class="search-drawer">
                <el-form :model="form" label-position="top" ref="form">
                    <el-form-item label="姓名：" >
                        <el-input @keydown.enter.native.stop="getDataList" clearable v-model="form.personName"></el-input>
                    </el-form-item>
                    <el-form-item label="身份证号：" >
                        <el-input @keydown.enter.native.stop="getDataList" clearable v-model="form.idcard"></el-input>
                    </el-form-item>
                    <el-form-item label="角色：">
                        <el-select @change="searchBtn" clearable style="width:100%;" v-model="form.roleType"  value-key="value">
                            <el-option label="全部" value="-99"></el-option>
                            <el-option :key="index"
                                       :label="item.name"
                                       :value="item.value"
                                       v-for="(item,index) in  rolesList"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="数据所属部门：">
                        <select-depart-tree 
                            ref="selectDepartTreeRef" 
                            :type="'2'"
                            :modelValue.sync="form.superviseDeptCodeList"  
                            :isMultiple="true" 
                            @handleDeptType="(val)=>changeDept(val,'5')" >
                            </select-depart-tree>
                    </el-form-item>
                </el-form>
                <div class="search-drawer__footer">
                    <el-button @click="searchBtn" size="small" type="primary">查询</el-button>
                    <el-button @click="refresh" plain size="small">重置</el-button>
                </div>
            </div>
        </searchBox>

        <div class="search-content">
            <div class="mainBtn">
                <el-button @click="routerAdd"  size="mini" type="primary" v-if="hasBtnPermission('btn_jz_facial_info_edit')">新增</el-button>
                <el-button @click="deleteSelectItem()" size="mini" v-if="hasBtnPermission('btn_jz_facial_info_delete')">删除</el-button>
            </div>
            <div class="searchBtn">
                <span class="label-form">姓名：</span>
                <el-input @keyup.enter.native="searchBtn" clearable placeholder="请输入内容搜索" style="width: 200px" v-model="form.personName"></el-input>
                <el-button @click="searchBtn" size="small" style="margin-left: 12px" type="primary">搜索</el-button>
                <el-button @click="moreSearchItem = true" icon="el-icon-arrow-down" size="mini" type="text">更多搜索</el-button>
                <el-divider direction="vertical"></el-divider>
                <el-button @click="refresh" icon="el-icon-refresh" type="text"></el-button>
            </div>
        </div>

      <el-table :data="tableData"
                :header-cell-style="this.$globalGrayTableHeaderStyle"
                class="table-content"
                ref="multipleTable"
                :height="tableMaxHeight"
                v-loading="dataListLoading"
                stripe
                border
                @selection-change="handleSelectionChange">
                <el-table-column fixed type="selection" v-if="hasBtnPermission('btn_jz_facial_info_delete')" align="center"
                         :show-overflow-tooltip='true'></el-table-column>
        <el-table-column fixed label="序号" type="index" :index="indexMethod" width="50" align="center"
                         :show-overflow-tooltip='true'></el-table-column>
        
        <el-table-column label="操作" fixed="right" align="center" width="100">
          <template slot-scope="scope">
            <el-button type="text" title="编辑"
                       v-if="hasBtnPermission('btn_jz_facial_info_edit')"
                       @click="router(scope.row)">编辑</el-button>
            <el-button type="text" title="删除"
                       v-if="hasBtnPermission('btn_jz_facial_info_delete')"
                       @click="deleteById(scope.row)">
              删除
            </el-button>
          </template>
        </el-table-column>


        <el-table-column label="头像缩略图" align="center" width='100'>
            <template slot-scope="scope">
                <img :src="scope.row.imgUrl" v-if="scope.row.imgUrl" class="thumbnail" alt="">
            </template>
        </el-table-column>
        <el-table-column label="姓名" prop='personName' header-align="center" align="center" min-width='120'
                         :show-overflow-tooltip='true'></el-table-column>
        <el-table-column label="身份证号" prop='idcard' header-align="center" align="center" min-width='100'
                         :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column label="角色" prop='roleTypeName' header-align="center" align="center" min-width='100'
                         :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column label="申请时间" prop='createTime' header-align="center" align="center" min-width='100'
                         :show-overflow-tooltip='true'>
        </el-table-column>
      </el-table>
      <el-pagination background
                     layout="total, sizes, prev, pager, next"
                     :page-sizes="[10, 20, 50, 100]"
                     :page-size="pageSize"
                     :total="total"
                     :current-page="pageIndex"
                     @size-change="sizeChangeHandle"
                     @current-change="currentChangeHandle"></el-pagination>
    </div>
  </div>
</template>

<script>
    import {mapState} from "vuex";
    import selectDepartTree from "@/views/modules/components/selectDepartTree"

    export default {
        components:{
            selectDepartTree
        },
  data() {
    return {
        tableMaxHeight: document.documentElement.clientHeight - 227,
        dataListLoading: false,
        form: {
            personName:"",
            idcard:"",
            search:'' ,//搜索框的值
            roleType:'-99',
            superviseDeptCodeList:[],// 数据所属部门
        },
        moreSearchItem: false,
        checkList1: '',
        pageSize: 10,//每页条数
        pageIndex: 1,//当前页
        total: 0,//总条数
        tableData: [],
        multipleSelection: [],
        user: '', //角色类型
        formData: {},
       rolesList:[],
    }
  },
  watch:{
      uerdefultOptionCode:{
        handler (val,oldVal){
          if(val.length!==0){this.getDataList()}
        }
    }
    },
  computed: {
    ...mapState({
      stateData: state => state.user,
      isAdmin: state => {return state.user.userinfo.selectRoleCode == "ADMIN"},
      uerdefultOptionCode: state => state.dataDictionary.uerdefultOptionCode,
    }),
  },
  filters: {
    ellipsis(text, num) {
      if (text.length > num) {
        return text.substring(0, num) + '...';
      } else {
        return text;
      }
    },
  },
    created() {
        this.getDic('jz_dgwitness_person_role');
    },
    activated() {
    //this.user = this.stateData.pageRoleIds //角色类型
    // this.refresh();
    this.getDataList()

  },
  mounted() {
    const that = this;
    let resizeTag = true
    window.onresize = () => {
      if (resizeTag) { //防抖动
        that.ifmove();
        resizeTag = false
        setTimeout(() => {
          resizeTag = true
        }, 1000)
      }
    }
    that.ifmove();
  },
  methods: {
    changeDept(val,str){//切换部门
            this.form.superviseDeptCodeList=[]
            if(str==='5'){
                // 多选
                val.forEach((item,index)=>{
                    if( item.type!=="region"){
                    this.form.superviseDeptCodeList.push(item.code)
                    }
                })
            }
        },
    ifmove() {
      // let hasBtnPermisson = this.hasBtnPermission("btn_jz_facial_info_edit") || this.hasBtnPermission("btn_jz_facial_info_delete");
      // let tableMaxHeight = document.documentElement.clientHeight - 227 +  (hasBtnPermisson ? 0 : 33);
        let tableMaxHeight = document.documentElement.clientHeight - 227;
        this.pageSize = parseInt((tableMaxHeight) / 70) || 1;
        this.$nextTick(() => {
            this.tableMaxHeight = tableMaxHeight
        })
      //this.getDataList()
    },

    getDic(type) { // 获取字典

      this.$httpReq.get('/sys/dictData/getList?type=' + type).then(res => {
        if (res.data.code === '1') {
          switch (type) {
            case 'jz_dgwitness_person_role':this. rolesList = res.data.data;break;
          }
        }
      })
    },



    getDataList() { // 获取列表数据
      this.form.superviseDeptCodeList= (this.form.superviseDeptCodeList || []).length==0?this.uerdefultOptionCode:this.form.superviseDeptCodeList

        this.dataListLoading=true;
      this.$httpReq.post('/document/sysPersonFaces/list', {
        'page': this.pageIndex,
        'rows': this.pageSize,
          roleType:this.form.roleType=="-99"?"":this.form.roleType,
          personName:this.form.personName,
          idcard:this.form.idcard,
          filter:{superviseDeptCodeList:this.form.superviseDeptCodeList||[]}
      }).then(res => {
          if(res.data.code =="1"){

              const data = res.data.data;
              this.tableData = data.rows;
              this.total = data.total;
              this.$refs.multipleTable.doLayout()
          }else{
              this.tableData =[];
              this.total = 0;
              this.$refs.multipleTable.doLayout()
          }
          this.dataListLoading=false;

      })
    },

    indexMethod(index) {
      return (this.pageIndex - 1) * this.pageSize + index + 1
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
      dialogCancle(){
          this.moreSearchItem = false
      },
    searchBtn() { //搜索按钮
      this.pageIndex = 1;
      this.moreSearchItem = false
      this.getDataList()
    },
    refresh() {//刷新按钮
        this.pageIndex = 1;
        this.form.roleType='-99';
        this.form.personName='';
        this.form.idcard='';
        this.form.tradeId='';
        this.moreSearchItem = false
        this.form.superviseDeptCodeList= this.uerdefultOptionCode
         // 重置默认所属数据
        if( this.$refs.selectDepartTreeRef){
        this.$refs.selectDepartTreeRef.getUserTreeOption()
    }
        this.getDataList()

    },

      routerAdd(){
          this.$router.push({
              name:'facial_info_detail',
              query:{
                  id:''
              }
          })
      },

    router(item){ // 跳转详情

      this.$router.push({
        name:'facial_info_detail',
        query:{
          id:item.id
        }
      })

    },



    deleteById(item) {
      this.$confirm(`确定要删除该数据?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
      this.$httpReq.post('/document/sysPersonFaces/delete', {
        id: item.id
      }).then(res => {
        if (res.data.code == '1') {
          this.$message({
            type: 'success',
            message: res.data.msg
          })
          this.getDataList();
        } else {
          this.$message({
            type: 'error',
            message: res.data.msg
          })
        }
      })
      })
    },
    deleteSelectItem() {
      let ids = new Array();
      this.multipleSelection.forEach(key => {
        ids.push(key.id)
      })

      if (ids != "" || ids.length > 0) {
        this.$httpReq.post('/cateQuestBase/delete', {
          idList: ids
        }).then(res => {
          if (res.data.code == '1') {
            this.$message({
              type: 'success',
              message: res.data.msg
            })
            this.getDataList();
          } else {
            this.$message({
              type: 'error',
              message: res.data.msg
            })
          }
        })
      } else {
        this.$message({
          type: 'error',
          message: "未选择删除项。"
        })
      }

    },

    sizeChangeHandle(val) {
      this.pageSize = val;
      this.pageIndex = 1
      this.getDataList()
    },

    currentChangeHandle(val) {
      this.pageIndex = val
      this.getDataList()
    },



  }


}
</script>

<style lang="scss">

    .thumbnail{
        width: 50px;
        height: 50px;
    }

.main_center {
  .top {
    .input_title {
      display: flex;
    }

    .el-form-item {
      margin-bottom: 0;
    }
  }
}

.margin-hide {
  .el-form-item__content {
    margin-left: 0 !important;
  }
}
</style>